import React, { useEffect, useState, useRef } from 'react';
import './TeachModule.css';

const TimelineNavigation = ({ timelineData, onPrev, onNext: _onNext, currentStepIndex }) => {
    // Animation state
    const [animClass, setAnimClass] = useState('');
    const prevStepRef = useRef(currentStepIndex);

    const data = timelineData && typeof timelineData === 'object' ? timelineData : { prev: null, current: null, next: null };

    useEffect(() => {
        if (currentStepIndex > prevStepRef.current) {
            setAnimClass('animating-next');
        } else if (currentStepIndex < prevStepRef.current) {
            setAnimClass('animating-prev');
        }
        prevStepRef.current = currentStepIndex;

        const timer = setTimeout(() => setAnimClass(''), 500);
        return () => clearTimeout(timer);
    }, [currentStepIndex]);

    return (
        <div className={`timeline-nav-container ${animClass}`}>
            {/* Previous Node */}
            <div
                className={`timeline-slot ${data.prev ? 'completed' : 'empty'}`}
                onClick={data.prev ? onPrev : undefined}
            >
                {data.prev && (
                    <>
                        <div className="timeline-dot" />
                        <span className="timeline-label">{timelineData.prev.label}</span>
                        <span className="timeline-status">COMPLETED</span>
                    </>
                )}
            </div>

            {/* Current Node */}
            <div className="timeline-slot active">
                <div className="timeline-dot" />
                <span className="timeline-label">{data.current?.label || 'LESSON'}</span>
                <span className="timeline-status">CURRENT</span>
            </div>

            {/* Next Node */}
            <div
                className={`timeline-slot ${data.next ? 'disabled' : 'empty'}`}
                onClick={data.next ? undefined : undefined} // Disabled by design until step complete
            >
                {data.next && (
                    <>
                        <div className="timeline-dot" />
                        <span className="timeline-label">{data.next.label}</span>
                        <span className="timeline-status">LOCKED</span>
                    </>
                )}
            </div>
        </div>
    );
};

export default TimelineNavigation;
